import { gql, DocumentNode } from '@apollo/client';
import { Box } from '@mui/material';
import React from 'react';
import { InvoiceEditAllowGratuity } from './InvoiceEditAllowGratuity';
import { AutomatedNotificationsToggle } from '../../AutomatedNotificationsToggle';
import styles from './InvoiceEditSettings.module.scss';
import {
	NotificationGroup,
	NotificationGroupProps,
} from '../../NotificationGroup';
import {
	EmailNotificationGroupTitle,
	InvoiceEditSettingsInvoiceFragment,
	InvoiceStatus,
} from '#types';
import rpcShared from '@rockpapercoin/rpc-shared';

const invoiceEditSettingsInvoiceFragment = gql`
	fragment invoiceEditSettingsInvoice on Invoice {
		id
		status
		allowsGratuity
		automatedRemindersEnabled
		paymentInstallments {
			id
			status
			amountDue
			paymentDate
		}
	}
`;

export type InvoiceEditSettingsProps = {
	invoice?: Omit<InvoiceEditSettingsInvoiceFragment, 'id'> & { id?: string };
	setInvoice: React.Dispatch<
	React.SetStateAction<
	Omit<InvoiceEditSettingsInvoiceFragment, 'id'> & { id?: string }
	>
	>;
	notificationGroupProps: Omit<NotificationGroupProps, 'groupTitle'>;
};

type InvoiceEditSettingsPropsWithFragment =
	React.FC<InvoiceEditSettingsProps> & {
		fragments: {
			invoiceEditSettingsInvoiceFragment: DocumentNode;
		};
	};

export const InvoiceEditSettings: InvoiceEditSettingsPropsWithFragment = ( {
	invoice,
	setInvoice,
	notificationGroupProps,
} ) => (
	<Box className={ styles.settings }>
		<InvoiceEditAllowGratuity
			checked={ invoice?.allowsGratuity ?? true }
			onChange={ ( _, checked ) =>
				setInvoice( ( prevState ) => ( { ...prevState, allowsGratuity: checked } ) )
			}
		/>
		<AutomatedNotificationsToggle
			checked={ invoice?.automatedRemindersEnabled ?? true }
			onChange={ ( _, checked ) =>
				setInvoice( ( prevState ) => ( {
					...prevState,
					automatedRemindersEnabled: checked,
				} ) )
			}
		/>
		<NotificationGroup
			groupTitle={ EmailNotificationGroupTitle.InvoiceCopy }
			disabled={
				rpcShared.invoices.calculateUnpaidBalance(
					invoice?.paymentInstallments
				) === 0 && invoice?.status !== InvoiceStatus.Draft
			}
			{ ...notificationGroupProps }
		/>
	</Box>
);

InvoiceEditSettings.fragments = {
	invoiceEditSettingsInvoiceFragment,
};
